import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";

@Injectable({
    providedIn: 'root',
})
export class UserService {
    constructor(
        private httpService: HttpClient,
        private keycloak: KeycloakService,
    ) {}

    delete(sub: string) {
        return this.httpService.delete(`/api/user/${sub}`);
    }

    getAll() {
        return this.httpService.get('/api/user/all');
    }

    getStats() {
        return this.httpService.get('/api/user/stats');
    }

    update(sub: string, user: any) {
        return this.httpService.patch(`/api/user/${sub}`, user);
    }

    // Admin-only: Freitext-Notiz der Kundenakte (adminNotes), eigener Endpoint
    // damit das Feld nie über das generische Profil-Update (siehe update()) läuft.
    updateAdminNotes(sub: string, adminNotes: string) {
        return this.httpService.patch(`/api/user/admin/${sub}/notes`, { adminNotes });
    }

    getUserName(): string {
        return this.keycloak.getUsername();
    }

    loadUserProfile(): Promise<KeycloakProfile> {
        return this.keycloak.loadUserProfile();
    }

    login(redirectPath: string = '/home/booking'): Promise<void> {
        return this.keycloak.login({
            redirectUri: window.location.origin + redirectPath,
        });
    }

    manageBilling() {
        return this.httpService.post(`/api/user/manage-billing`, {});
    }

    async logout() {
        this.keycloak.logout(environment.hostName).then(() => {});
    }

    isLoggedIn(): Promise<boolean> {
        return this.keycloak.isLoggedIn();
    }

    getUser(): Observable<any> {
        return this.httpService.get('/api/user');
    }
}
